import { clientShortList } from '@requests/services/services'

export const shortList = {
  namespaced: true,
  state: {
    shortList: [],
  },
  getters: {
    getShortList: state => state.shortList,
  },
  actions: {
    shortListRequest({ commit }) {
      const path = window.location.pathname;

      const parts = path.split('/');
      const lastPart = parts[parts.length - 1];
      const number = parseInt(lastPart, 10);

      return clientShortList.execute({ id: number }).then(({ shortlist: shortListData }) => {
        commit('setShortList', shortListData)
      })
    },
  },
  mutations: {
    setShortList: (state, response) => { state.shortList = response },
  },
}
